<h1 class="configure-hours-workshop-dialog__title" mat-dialog-title>{{"SetAvailableHours" | translate}}</h1>
<div mat-dialog-content class="configure-hours-workshop-dialog">

    <div class="loading-container" *ngIf="!dropdownData">
            <section>
              <div  class="pulsing">
                <mat-spinner [diameter]="50" ></mat-spinner>
              </div>
              <p class="pulsing">{{"Searching" | translate}}</p>
            </section>
          
    </div>
    
    <section class="configure-hours-workshop-dialog__hours" *ngIf="dropdownData">

        <article class="configure-hours-workshop-dialog__hour col-lg-12" 
                 *ngFor="let day of daysOfWeeks; let i = index;">
                 <p class="configure-hours-workshop-dialog__day">{{day.day | translate}}</p>
                 <mat-slide-toggle [(ngModel)]="day.isActive"[disabled]="day.isActiveWork "></mat-slide-toggle>

                 <mat-form-field>
                    <mat-label><i class="bi bi-clock"></i> {{"StartTime" | translate}}</mat-label>
                    <mat-select *ngIf="i === 0" [(ngModel)]="day.startTime"  >
                        <mat-option *ngFor="let hours of day.arrayHours" [value]="hours" [disabled]="day.isActiveWork " >{{hours}}</mat-option>
                    </mat-select>
                    <mat-select *ngIf="i > 0"   [(ngModel)]="day.startTime"
                        [disabled]="isCopyHoursOfMonday" >
                            <mat-option *ngFor="let hours of day.arrayHours" (click)="ValidationOfCorrectHoursAdvisor(i)" [value]="hours" >{{hours}}</mat-option>
                        </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label><i class="bi bi-clock"></i> {{"TimeEnd" | translate}}</mat-label>
                    <mat-select *ngIf="i === 0" [(ngModel)]="day.endTime" >
                        <mat-option *ngFor="let hours of day.arrayHours" (click)="ValidationOfCorrectHoursAdvisor(i)" [value]="hours" >{{hours}}</mat-option>
                    </mat-select>
                    <mat-select *ngIf="i > 0"   [(ngModel)]="day.endTime"
                       [disabled]="isCopyHoursOfMonday">
                        <mat-option *ngFor="let hours of day.arrayHours"(click)="ValidationOfCorrectHoursAdvisor(i)" [value]="hours" >{{hours}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <p *ngIf="day.validateHours" class="Funcion_horas">
                    (*) Verifique que la hora Inicial sea menor a la hora final
                  </p>
                  
        </article>
        
        <article class="">
            <mat-checkbox class="checkbox-color configure-hours-workshop-dialog__copy" [(ngModel)]="isCopyHoursOfMonday">{{"CopySchedule" | translate}}</mat-checkbox>
        </article>

    </section>

</div>

<mat-dialog-actions align="center">
    <button class="dialog__button" (click)="onCancel()">
        {{"Cancel" | translate}}
    </button>
    <button class="dialog__button dialog__button--fill" (click)="onSave()">
        {{"Accept" | translate}}
    </button>
</mat-dialog-actions >
